import React, { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { StyledActionsButtonLink } from './StyledComponents';
import { messages } from '../../messages';
import { DetailsRow } from './DetailsRowContentElements/DetailsRow';
import { StyledPipe } from './ActionsSectionElements/StyledPipe';
import { AccountRenewalAction } from 'util/mac/enums';
import { AnnualCancelAutoRenewModal } from './AnnualCancelAutoRenewModal';
import { removeTimezone } from 'modules/mac/common/utils';
import PaymentDetailsSection from './DetailsRowContentElements/licensesRowPaymentDetails';
import { useSelector } from 'react-redux';
import { selectIsOnBehalfOfEmail, selectTrackedElsewhere } from '../../duck/selectors';
import { hostedAccountTypes } from '../../../../util/mac/helpers';
import { State } from '../../../../model/State';

const AnnualDetailsSection = ({ accountDetails, isAutoRenewable }) => {
  const {
    id: accountId,
    latestPeriod,
    renewalAction,
    productDescription,
    merchandise = {},
    productPackage: defaultProductPackage,
  } = accountDetails;
  const productPackage = merchandise.productPackage || defaultProductPackage;
  const { key, productType } = productPackage;
  const isAccountHosted = hostedAccountTypes.includes(productType);
  const [isOpen, setIsOpen] = useState(false);
  const isOnBehalfOfEmail: any = useSelector(selectIsOnBehalfOfEmail);
  const isTrackedElsewhere: boolean = useSelector((state) =>
    selectTrackedElsewhere(state as State, accountDetails.id),
  );

  const closeModal = () => setIsOpen(false);

  const MessageForAutoRenewOn = (
    <span data-cy="mac-annual-auto-renew-on">
      <FormattedMessage {...messages.on} /> <StyledPipe />
      <StyledActionsButtonLink onClick={() => setIsOpen(true)}>
        <FormattedMessage {...messages.turnAutoRenewOff} />
      </StyledActionsButtonLink>
    </span>
  );
  const MessageForAutoRenewOff = (
    <span data-cy="mac-annual-auto-renew-off">
      <FormattedMessage {...messages.off} /> <StyledPipe />
      {new Date(latestPeriod.endDate) > new Date() ? (
        <a href={`my/enable-auto-renew/${accountId}`}>
          <FormattedMessage {...messages.turnAutoRenewOn} />
        </a>
      ) : (
        <FormattedMessage {...messages.noAutoRenew} />
      )}
    </span>
  );

  return (
    <>
      {isAutoRenewable && (
        <DetailsRow
          label={<FormattedMessage {...messages.autoRenew} />}
          value={
            renewalAction === AccountRenewalAction.AUTO_RENEW
              ? MessageForAutoRenewOn
              : MessageForAutoRenewOff
          }
          dataCy="mac-annual-auto-renew"
        />
      )}
      {isAutoRenewable && (
        <DetailsRow
          dataCy="end-date"
          label={<FormattedMessage {...messages.renewsOn} />}
          value={
            <FormattedDate
              value={removeTimezone(accountDetails?.latestPeriod?.endDate)}
              day="2-digit"
              month="long"
              year="numeric"
            />
          }
        />
      )}
      <AnnualCancelAutoRenewModal
        isOpen={isOpen}
        closeModal={closeModal}
        productDescription={productDescription}
        accountId={accountId}
      />

      {isAutoRenewable &&
        !isTrackedElsewhere &&
        !isAccountHosted &&
        (!accountDetails?.partnerManaged || isOnBehalfOfEmail?.contactPartnerForAccount) &&
        accountDetails?.renewalAction === AccountRenewalAction.AUTO_RENEW && (
          <PaymentDetailsSection
            data-cy="provide-payment-details-annual"
            accountDetails={accountDetails}
            productKey={key}
          />
        )}
    </>
  );
};

export default AnnualDetailsSection;
